module.exports = __webpack_public_path__ + "assets/img/open_microphone.06286183.png";